var render = function () {
  var _vm$getPickup;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "delivery-type"
  }, [_vm.getPickup ? _c('div', {
    staticClass: "delivery-type__item delivery-type__item_pickup"
  }, [(_vm$getPickup = _vm.getPickup) !== null && _vm$getPickup !== void 0 && _vm$getPickup.name ? _c('p', {
    staticClass: "delivery-type__item-title"
  }, [_vm._v("\n      " + _vm._s(_vm.getPickup.name) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('AvailabilityModal', {
    attrs: {
      "availability": _vm.availability
    },
    scopedSlots: _vm._u([{
      key: "handler",
      fn: function () {
        return [_vm.getPickup.cost ? _c('p', {
          staticClass: "delivery-type__item-name"
        }, [_vm._v("\n          " + _vm._s(_vm.getPickup.cost) + ",\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "delivery-type__item-value"
        }, [_vm._v(" в " + _vm._s(_vm.convertText) + " ")])];
      },
      proxy: true
    }], null, false, 1154597662)
  })], 1) : _vm._e(), _vm._v(" "), _vm.getDelivery ? _c('div', {
    staticClass: "delivery-type__item delivery-type__item_delivery"
  }, [_c('p', {
    staticClass: "delivery-type__item-title"
  }, [_vm._v("\n      Доставка\n    ")]), _vm._v(" "), _vm.getDelivery.cost ? _c('p', {
    staticClass: "delivery-type__item-name"
  }, [_vm._v("\n      " + _vm._s(_vm.getDelivery.cost) + ",\n    ")]) : _vm._e(), _vm._v(" "), _vm.getDelivery.date ? _c('p', {
    staticClass: "delivery-type__item-name"
  }, [_vm._v("\n      " + _vm._s(_vm.getDelivery.date) + "\n    ")]) : _vm._e()]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }